import React, { useMemo } from 'react';
import { BodySmall } from '../../atoms/fonts/Body';
import './team-drop-down-list.scss';
import Colours from "../../atoms/Colours";
import { useTranslation } from "react-i18next";
import { Department } from "../../../../components/pages/departments/data/departments.models";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { REACT_SELECT_DROPDOWN_STYLES } from "../OfficeDropDownList";
import i18next from "i18next";

const ALL_DEPARTMENTS = 'ALL';
const animatedComponents: any = makeAnimated();

export default function DepartmentDropDownList(props: Props) {
  const { onSelect, selectedDepartmentId, className, label } = props;
  const {t} = useTranslation();

  const onItemSelected = (e: any) => {
    if (e.value !== undefined && e.value !== 'none') {
      onSelect(e.value)
    }
  }

  const options = useMemo(() => {
    const retVal: any[] = [];

    if (props.includeAllDepartments) {
      retVal.push({ value: ALL_DEPARTMENTS, label: i18next.t('general.all-departments') });
    }

    if (props.includeNoDepartment) {
      retVal.push({ value: 0, label: i18next.t('general.no-department') });
    }

    (props.departments ?? []).forEach(d => retVal.push({ value: d.id, label: d.name }));

    return retVal;
  }, [props.includeAllDepartments, props.includeNoDepartment, props.departments]);

  const placeholder = props.includeAllDepartments
    ? i18next.t('general.all-departments')
    : i18next.t('general.select-department');

  return (
    <>
      {!!label && <BodySmall colour={Colours.darkGrey} weight={600} className="teamDropDownList__label">{t(label)}</BodySmall>}
      <Select
        options={options}
        onChange={onItemSelected}
        value={options.find((o: any) => o.value === selectedDepartmentId) || null}
        placeholder={placeholder}
        closeMenuOnSelect={true}
        styles={REACT_SELECT_DROPDOWN_STYLES}
        components={{ ...animatedComponents, ClearIndicator: () => null, IndicatorSeparator: () => null }}
        isMulti={false}
        isDisabled={props.disabled}
        className={`teamDropDownList ${className ?? ''}`.trim()}
      />
    </>
  )
}


interface Props {
  departments: Department[],
  onSelect: (departmentId: number) => any,
  selectedDepartmentId?: number,
  className?: string,
  label?: string,
  disabled?: boolean,
  includeAllDepartments?: boolean,
  includeNoDepartment?: boolean,
}
